//React component for a channel's profile page
import { Box, Button, ButtonGroup, Grid2, Tooltip, Typography } from "@mui/material";
import { useNavigate, useParams } from "react-router";
import { fetchChannelData } from "../../utilities/apiRequests.js";
import ChannelPageTable from "./ChannelPageTable.js";
import { useEffect, useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { useHandleResizeError } from "../../utilities/handleResizeError.js";
import HeaderBar from "../Shared/HeaderBar/HeaderBar.js";
import NavigationBar from "../Shared/NavigationBar/NavigationBar.js"
import { getLogoUrl } from "../../utilities/consts.js";
import ChannelSchedule from "./ChannelSchedule/ChannelSchedule.js";

const VIEWS = Object.freeze({
    INFO: "info",
    SCHEDULE: "schedule"
});

export default function ChannelPage(){

    useHandleResizeError()
    
    const { getAccessTokenSilently } = useAuth0();
    const { channelID } = useParams();
    const navigate = useNavigate();
    const logoUrl = getLogoUrl();

    const [viewSelected, setViewSelected] = useState(VIEWS.INFO);

    // fetch rows from api
    const [channelData, setChannelData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    useEffect(() => {
        getAccessTokenSilently({ authorizationParams: { scope: "read:channels" } })
            .then((accessToken) => fetchChannelData(channelID, accessToken))
            .then((fetchedChannelData) => setChannelData(fetchedChannelData))
            .catch((error) => {
                console.error("Error fetching channel data:", error);
                navigate("/stationspage");
                setError(true);
            })
            .finally(() => setLoading(false));
    }, [getAccessTokenSilently, navigate, channelID]);

    if (loading) {
        return (
            <Box sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center"
            }}>
                <Typography>Loading...</Typography>
            </Box>
        );
    }

    if (error) return;

                      
    // fallback logo in case logo does not exist
    function loadStationLogo(e) {
        e.target.onError = null;
        e.target.style.backgroundColor = 'var(--mui-palette-background-default)'; //sets background color to white for sinclair logo case
        e.target.src = "/logos/sinclair-logo-black.svg";
    }

    let market = (channelData.market) ? channelData.market : ""
    let call_sign = (channelData.call_sign) ? channelData.call_sign : ""
    let affiliation = (channelData.affiliation) ? " (" + channelData.affiliation  + ")" : ""

    let pageTitle = market + " " + call_sign + affiliation

    return (
        <>
            <HeaderBar page={"ChannelPage"} channelID={channelID}></HeaderBar>
            <Grid2 container={true} justifyContent={'center'} alignItems={'center'} direction={'column'} id={"ChannelPageGrid"} paddingBottom={'0.75em'}>
                <Box component="img" src={`${logoUrl}/${channelID}.svg`} alt={"Station Logo"} onError={(e) => loadStationLogo(e)} backgroundColor="primary.main" 
                    paddingTop={'0.75em'}
                    paddingBottom={'1em'}
                    height="4.5em"
                />
                <Tooltip title={"Click any cell to copy it to your clipboard."} placement='bottom'>
                    <Typography variant={"h3"} textAlign={'center'} fontSize={'1.5em'}>{pageTitle}</Typography>
                </Tooltip>

                <ButtonGroup sx={{
                    margin: "1em"
                }}>
                    <Button
                        variant={viewSelected === VIEWS.INFO ? "contained" : "outlined"}
                        onClick={() => setViewSelected(VIEWS.INFO)}
                    >
                        Info
                    </Button>
                    <Button
                        variant={viewSelected === VIEWS.SCHEDULE ? "contained" : "outlined"}
                        onClick={() => setViewSelected(VIEWS.SCHEDULE)}
                    >
                        Schedule
                    </Button>
                </ButtonGroup>

                {viewSelected === VIEWS.INFO && <ChannelPageTable row={channelData} />}
                {viewSelected === VIEWS.SCHEDULE && <ChannelSchedule channelID={channelID} />}

                <br/><br/><br/>
            </Grid2>
            <NavigationBar></NavigationBar>
        </>
    );
}
